import { render } from "./ContactTransportModePageList.vue?vue&type=template&id=2839a876&scoped=true&ts=true"
import script from "./ContactTransportModePageList.vue?vue&type=script&lang=ts"
export * from "./ContactTransportModePageList.vue?vue&type=script&lang=ts"

import "./ContactTransportModePageList.vue?vue&type=style&index=0&id=2839a876&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2839a876"]])

export default __exports__